import React from 'react'

const NotPayment = ({
  color = '#4E60FF',
  firstColor = '#F1F2FF',
}: {
  color?: string
  firstColor?: string
}) => {
  return (
    <svg
      width='125'
      height='124'
      viewBox='0 0 125 124'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15 64.0503V41.2005C15 35.2505 18.65 29.9503 24.2 27.8503L63.9 12.8503C70.1 10.5003 76.75 15.1004 76.75 21.7504V40.7504'
        fill={firstColor}
      />
      <path
        d='M15 64.0503V41.2005C15 35.2505 18.65 29.9503 24.2 27.8503L63.9 12.8503C70.1 10.5003 76.75 15.1004 76.75 21.7504V40.7504'
        stroke={color}
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M89.7 77.9C90.15 83.3 95.1 87.2499 100.5 87.2499H110V93.2C110 103.55 101.55 112 91.2 112H40.65C42.2 110.7 43.55 109.1 44.6 107.3C46.45 104.3 47.5 100.75 47.5 97C47.5 85.95 38.55 77 27.5 77C22.8 77 18.45 78.65 15 81.4V59.55C15 49.2 23.45 40.75 33.8 40.75H91.2C101.55 40.75 110 49.2 110 59.55V66.7501H99.9C97.1 66.7501 94.55 67.8499 92.7 69.7499C90.6 71.7999 89.4 74.75 89.7 77.9Z'
        fill={firstColor}
        stroke={color}
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M115.294 82.1511C115.294 84.9011 113.094 87.1509 110.294 87.2509H100.494C95.0941 87.2509 90.1441 83.3009 89.6941 77.9009C89.3941 74.7509 90.5941 71.8009 92.6941 69.7509C94.5441 67.8509 97.0941 66.751 99.8941 66.751H110.294C113.094 66.851 115.294 69.1008 115.294 71.8508V82.1511Z'
        fill={firstColor}
        stroke={color}
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M37.5 62H72.5'
        stroke={color}
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M44.6 107.3C43.55 109.1 42.2 110.7 40.65 112C37.15 115.15 32.55 117 27.5 117C20.2 117 13.85 113.1 10.4 107.3C8.55001 104.3 7.5 100.75 7.5 97C7.5 90.7 10.4 85.05 15 81.4C18.45 78.65 22.8 77 27.5 77C38.55 77 47.5 85.95 47.5 97C47.5 100.75 46.45 104.3 44.6 107.3Z'
        fill={firstColor}
        stroke={color}
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M32.8498 102.2L22.2498 91.6497'
        stroke={color}
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M32.7497 91.7998L22.1497 102.35'
        stroke={color}
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        opacity='0.01'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M122.5 2V122H2.5V2H122.5Z'
        stroke={color}
        strokeWidth='4'
      />
    </svg>
  )
}

export default NotPayment
